import React, { createContext, useContext, useState, useCallback } from 'react'
import { Spin } from 'antd'

const LoadingContext = createContext()

export const useGlobalLoading = () => useContext(LoadingContext)

export function LoadingProvider({ children }) {
  const [loadingCount, setLoadingCount] = useState(0)

  const startLoading = useCallback(() => {
    setLoadingCount(prev => prev + 1)
  }, [])

  const stopLoading = useCallback(() => {
    setLoadingCount(prev => Math.max(prev - 1, 0))
  }, [])

  const loading = loadingCount > 0

  return (
    <LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
      {children}

      {loading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'wait'
          }}
        >
          <Spin size="large" tip="Loading, please wait..." />
        </div>
      )}
    </LoadingContext.Provider>
  )
}